export default function initReveal() {
  const elements = document.querySelectorAll('[data-reveal]')
  if (!elements.length) return

  const createObserver = (rootMargin) => {
    const obs = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return

        let delay = parseInt(entry.target.dataset.revealDelay || 0, 10)

        const parent = entry.target.closest('[data-reveal-stagger]')
        if (parent) {
          const stagger = parseInt(parent.dataset.revealStagger || 100, 10)
          const siblings = Array.from(parent.querySelectorAll('[data-reveal]'))
          const index = siblings.indexOf(entry.target)
          delay += index * stagger
        }

        setTimeout(() => entry.target.classList.add('is-visible'), delay)
        obs.unobserve(entry.target)
      })
    }, { threshold: 0.05, rootMargin })
    return obs
  }

  const defaultObs = createObserver('0px 0px -20px 0px')
  const earlyObs = createObserver('0px 0px 250px 0px')

  elements.forEach((el) => {
    const obs = el.closest('.slider-img') ? earlyObs : defaultObs
    obs.observe(el)
  })
}
